// Lux Coffee: välkomstpopupen "Lux-lotten" (sections/lux-popup.liquid). Portad från lux-website/popup-skiss.html.
// En ny lott vid varje visning: tre rutor med vinstvärdet på slumpade platser, sex rutor med övriga värden
// (inget av dem tre gånger) och Extrachansen. Kunden drar myntet över lotten; en ruta räknas som skrapad när
// minst 30 % av silvret är borta. Erbjudandet är klart först när alla nio rutor och Extrachansen är skrapade.
// Sedan fråga → e-post (Shopifys kundformulär via fetch) → vidare till Kaffeboxen med rabatten i bakgrunden.
(function () {
  "use strict";

  var KEY = "luxLotten";        // localStorage: { until: tidsstämpel } – visa inte igen före detta
  var TAB_KEY = "luxLottenTab"; // sessionStorage: "1" = visa fliken "Din lott väntar" under besöket
  var DAY = 864e5;
  var CLEAR_ALPHA = 40;         // pixel räknas som skrapad under detta alfavärde
  var CLEAR_SHARE = 0.3;        // andel skrapade pixlar som öppnar rutan

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mqReduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  var isDesign = function () { return !!(window.Shopify && window.Shopify.designMode); };

  var readUntil = function () {
    try { var v = JSON.parse(window.localStorage.getItem(KEY) || "null"); return (v && +v.until) || 0; } catch (e) { return 0; }
  };
  var writeUntil = function (days) {
    try { window.localStorage.setItem(KEY, JSON.stringify({ until: Date.now() + days * DAY })); } catch (e) { /* lagring blockerad */ }
  };
  var session = function (k, v) {
    try {
      if (v === undefined) return window.sessionStorage.getItem(k);
      if (v === null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v);
    } catch (e) { /* lagring blockerad */ }
    return null;
  };

  var shuffle = function (a) {
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  };

  // Nio värden: vinsten exakt tre gånger, övriga högst två gånger var.
  var makeValues = function (win, othersStr) {
    var others = [];
    String(othersStr || "").split(/[^0-9.]+/).forEach(function (s) {
      var n = parseFloat(s);
      if (isFinite(n) && n > 0 && n !== win && others.indexOf(n) === -1) others.push(n);
    });
    var pool = [];
    others.forEach(function (v) { pool.push(v, v); });
    for (var k = 5; pool.length < 6 && k < 100; k += 5) {
      if (k !== win && others.indexOf(k) === -1) pool.push(k, k);
    }
    var vals = shuffle(pool).slice(0, 6).concat([win, win, win]);
    return shuffle(vals);
  };

  var fmt = function (n) { return String(n).replace(".", ",") + " %"; };

  // Lyckohjulet: åtta fält. Vinsten i fält 0 och 4, övriga värden i resten (fylls på med 5, 10, 15 … vid behov).
  var WHEEL_FIELDS = 8;
  var wheelValues = function (prize, othersStr) {
    var others = [];
    String(othersStr || "").split(/[^0-9.]+/).forEach(function (s) {
      var n = parseFloat(s);
      if (isFinite(n) && n > 0 && n !== prize && others.indexOf(n) === -1) others.push(n);
    });
    for (var k = 5; others.length < 3 && k < 100; k += 5) if (k !== prize && others.indexOf(k) === -1) others.push(k);
    var vals = [], o = 0;
    for (var i = 0; i < WHEEL_FIELDS; i++) vals.push(i % 4 === 0 ? prize : others[o++ % others.length]);
    return vals;
  };
  // Fälten som SVG (viewBox -100..100). Fält i börjar i vinkeln i × 45° medurs från toppen.
  var wheelSvg = function (vals) {
    var n = vals.length, step = 360 / n, r = 92;
    var pt = function (deg, rad) { var a = (deg - 90) * Math.PI / 180; return [rad * Math.cos(a), rad * Math.sin(a)]; };
    var svg = '<svg viewBox="-100 -100 200 200" xmlns="http://www.w3.org/2000/svg">';
    svg += '<circle r="99" class="lp-wheel__rim"/>';
    for (var i = 0; i < n; i++) {
      var a0 = i * step, a1 = a0 + step, p0 = pt(a0, r), p1 = pt(a1, r), mid = a0 + step / 2;
      svg += '<path class="lp-wheel__f lp-wheel__f--' + i + '" d="M0 0L' + p0[0].toFixed(2) + " " + p0[1].toFixed(2) +
        "A" + r + " " + r + " 0 0 1 " + p1[0].toFixed(2) + " " + p1[1].toFixed(2) + 'Z"/>';
      // Texten ligger längs fältets mittlinje, som på referenshjulen, och vänds så att den läses från vänster till höger
      var turn = mid < 180 ? -90 : 90;
      svg += '<text class="lp-wheel__t lp-wheel__t--' + i + '" transform="rotate(' + mid + ') translate(0 -60) rotate(' + turn + ')" text-anchor="middle" dominant-baseline="central">' +
        fmt(vals[i]).replace(/\s/, " ") + "</text>";
    }
    for (var d = 0; d < 24; d++) { var b = pt(d * 15 + 7.5, 95.6); svg += '<circle class="lp-wheel__bulb" cx="' + b[0].toFixed(2) + '" cy="' + b[1].toFixed(2) + '" r="1.5"/>'; }
    return svg + "</svg>";
  };

  var paintSilver = function (c) {
    var r = c.getBoundingClientRect();
    var d = window.devicePixelRatio || 1;
    var ctx = c.getContext("2d", { willReadFrequently: true });
    c.width = Math.max(1, Math.round(r.width * d));
    c.height = Math.max(1, Math.round(r.height * d));
    ctx.setTransform(d, 0, 0, d, 0, 0);
    ctx.globalCompositeOperation = "source-over";
    var g = ctx.createLinearGradient(0, 0, r.width, r.height);
    g.addColorStop(0, "#a8a29a"); g.addColorStop(0.35, "#e9e5df"); g.addColorStop(0.6, "#bdb7ae"); g.addColorStop(1, "#9d978f");
    ctx.fillStyle = g; ctx.fillRect(0, 0, r.width, r.height);
    ctx.strokeStyle = "rgba(255,255,255,.18)"; ctx.lineWidth = 1;
    for (var x = -r.height; x < r.width; x += 7) { ctx.beginPath(); ctx.moveTo(x, r.height); ctx.lineTo(x + r.height, 0); ctx.stroke(); }
    for (var i = 0; i < r.width * r.height / 30; i++) {
      ctx.fillStyle = "rgba(0,0,0," + (Math.random() * 0.08) + ")";
      ctx.fillRect(Math.random() * r.width, Math.random() * r.height, 1, 1);
    }
    ctx.fillStyle = "rgba(42,28,20,.55)"; ctx.font = '500 10px "DM Sans", sans-serif'; ctx.textAlign = "center"; ctx.textBaseline = "middle";
    ctx.fillText("LUX", r.width / 2, r.height / 2);
    c._w = c.width;
  };

  var instances = [];

  var init = function (root) {
    if (!root || root.dataset.lpInit) return;
    root.dataset.lpInit = "1";

    var wrap = root.parentElement;
    var dialog = $("[data-lp-dialog]", root);
    var scroller = $("[data-lp-scroll]", root);
    var ticket = $("[data-lp-ticket]", root);
    var cells = $$("[data-lp-cell]", root);
    var bonus = $("[data-lp-bonus]", root);
    var grid = cells.filter(function (c) { return c !== bonus; });
    var coin = $("[data-lp-coin]", root);
    var result = $("[data-lp-result]", root);
    var cta = $('[data-lp-go="2"]', root);
    var autoBtn = $("[data-lp-auto]", root);
    var flakesCv = $("[data-lp-flakes]", root);
    var fctx = flakesCv.getContext("2d");
    var form = $("#lux-popup-form", root);
    var email = $("[data-lp-email]", root);
    var err = $("[data-lp-error]", root);
    var tags = $("[data-lp-tags]", root);
    var tabWrap = $("[data-lp-tabwrap]", wrap);
    var tabBtn = $("[data-lp-open]", wrap);

    var cfg = {
      delay: +root.dataset.delay || 0,
      scroll: +root.dataset.scroll || 0,
      days: +root.dataset.days || 14,
      win: parseFloat(root.dataset.win) || 25,
      others: root.dataset.others || "",
      redirect: root.dataset.redirect || "/products/kaffeboxen",
      editorAlways: root.dataset.editorAlways === "true"
    };

    var ac = window.AbortController ? new AbortController() : null;
    var on = function (el, ev, fn, opts) {
      if (!el) return; // elementet finns bara i det ena spelet (hjul eller lott)
      var o = opts || {};
      if (ac) o.signal = ac.signal;
      el.addEventListener(ev, fn, o);
    };

    var isOpen = false, step = 1, lastFocus = null, timers = [], autoRunning = false, lastText = null;

    /* ---------- Lotten ---------- */
    var newTicket = function () {
      var vals = makeValues(cfg.win, cfg.others);
      grid.forEach(function (c, i) {
        c.classList.remove("is-open", "is-win");
        c.dataset.v = vals[i];
        if (vals[i] === cfg.win) c.dataset.win = "1"; else delete c.dataset.win;
        $(".lp-v", c).textContent = fmt(vals[i]);
        $("canvas", c)._w = 0;
      });
      bonus.classList.remove("is-open");
      $("canvas", bonus)._w = 0;
      var no = $("[data-lp-no]", root);
      if (no) no.textContent = String(Math.floor(Math.random() * 9999) + 1).padStart(4, "0");
      ticket.classList.add("is-shine");
      result.textContent = ""; lastText = "";
      cta.disabled = true;
    };

    var paintCells = function (force) {
      cells.forEach(function (c) {
        if (c.classList.contains("is-open")) return;
        var cv = $("canvas", c);
        var want = Math.round(cv.getBoundingClientRect().width * (window.devicePixelRatio || 1));
        if (force || !cv._w || Math.abs(cv._w - want) > 2) paintSilver(cv);
      });
    };

    var setText = function (t) {
      if (t === lastText) return;
      lastText = t; result.textContent = t;
    };

    var update = function () {
      var opened = grid.filter(function (c) { return c.classList.contains("is-open"); });
      var wins = opened.filter(function (c) { return c.dataset.win; });
      var bonusOpen = bonus.classList.contains("is-open");
      var all = opened.length === grid.length;
      if (wins.length >= 3) wins.forEach(function (c) { c.classList.add("is-win"); });
      var d = result.dataset;
      if (!opened.length && !bonusOpen) setText("");
      else if (wins.length < 3) setText(d.tProgress);
      else if (!bonusOpen) setText(d.tThree);
      else if (!all) setText(d.tRest);
      else setText(d.tDone);
      var ready = all && bonusOpen;
      if (ready && cta.disabled && isOpen) {
        // På mobil kan knappen ligga under kanten på arket: visa den när lotten är klar.
        window.setTimeout(function () {
          if (!dragging) cta.scrollIntoView({ block: "nearest", behavior: mqReduce.matches ? "auto" : "smooth" });
        }, 400);
      }
      cta.disabled = !ready;
    };

    var openCell = function (c) {
      if (c.classList.contains("is-open")) return;
      c.classList.add("is-open");
      update();
    };

    /* ---------- Flagor ---------- */
    var flakes = [], raf = null;
    var sizeFlakes = function () {
      var r = dialog.getBoundingClientRect();
      flakesCv.width = Math.max(1, Math.round(r.width));
      flakesCv.height = Math.max(1, Math.round(r.height));
    };
    var tick = function () {
      fctx.clearRect(0, 0, flakesCv.width, flakesCv.height);
      flakes = flakes.filter(function (p) { return p.life > 0; });
      flakes.forEach(function (p) {
        p.vy += 0.35; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.life--;
        fctx.save(); fctx.translate(p.x, p.y); fctx.rotate(p.rot); fctx.fillStyle = p.c;
        fctx.globalAlpha = Math.min(1, p.life / 20); fctx.fillRect(-p.s / 2, -p.s / 4, p.s, p.s / 2); fctx.restore();
      });
      raf = flakes.length ? window.requestAnimationFrame(tick) : null;
    };
    var burst = function (x, y, n, colors) {
      if (mqReduce.matches) return;
      var pr = dialog.getBoundingClientRect();
      for (var i = 0; i < (n || 4); i++) {
        flakes.push({
          x: x - pr.left, y: y - pr.top, vx: (Math.random() - 0.5) * 5, vy: -Math.random() * 3, vr: (Math.random() - 0.5) * 0.4,
          rot: Math.random() * 6, s: 3 + Math.random() * 4, life: 40 + Math.random() * 30, c: (colors || ["#cfc9c1", "#e9e5df", "#a8a29a"])[i % (colors || [0, 0, 0]).length]
        });
      }
      if (!raf) raf = window.requestAnimationFrame(tick);
    };

    /* ---------- Skrapning ---------- */
    var lastPt = null;
    var scratchTo = function (x, y) {
      var pts = [];
      if (lastPt) {
        var dx = x - lastPt[0], dy = y - lastPt[1], n = Math.max(1, Math.ceil(Math.sqrt(dx * dx + dy * dy) / 6));
        for (var i = 1; i <= n; i++) pts.push([lastPt[0] + dx * i / n, lastPt[1] + dy * i / n]);
      } else pts.push([x, y]);
      lastPt = [x, y];
      var cw = coin.offsetWidth || 80, rx = cw * 0.3, ry = cw * 0.21, hit = false;

      cells.forEach(function (c) {
        if (c.classList.contains("is-open")) return;
        var cv = $("canvas", c), r = cv.getBoundingClientRect();
        var near = pts.filter(function (p) { return p[0] > r.left - rx && p[0] < r.right + rx && p[1] > r.top - ry && p[1] < r.bottom + ry; });
        if (!near.length) return;
        var ctx = cv.getContext("2d", { willReadFrequently: true });
        ctx.save();
        ctx.globalCompositeOperation = "destination-out";
        ctx.fillStyle = "rgba(0,0,0,1)"; // ogenomskinligt sudd, annars blir silvret bara halvgenomskinligt
        near.forEach(function (p) { ctx.beginPath(); ctx.ellipse(p[0] - r.left, p[1] - r.top, rx, ry, -0.5, 0, Math.PI * 2); ctx.fill(); });
        ctx.restore();
        hit = true;
        var px = ctx.getImageData(0, 0, cv.width, cv.height).data, clear = 0, total = 0;
        for (var k = 3; k < px.length; k += 40) { total++; if (px[k] < CLEAR_ALPHA) clear++; }
        if (total && clear / total > CLEAR_SHARE) openCell(c);
      });
      if (hit) burst(x, y, 3);
    };

    /* ---------- Myntet ---------- */
    var dragging = false, rest = null;
    var moveCoin = function (e) {
      if (!dragging) return;
      coin.style.transform = "translate(" + (e.clientX - rest.x) + "px," + (e.clientY - rest.y) + "px) scale(1.08) rotate(-12deg)";
      var w = coin.offsetWidth;
      scratchTo(e.clientX + w * 0.18, e.clientY + w * 0.18);
    };
    var endDrag = function () {
      if (!dragging) return;
      dragging = false; lastPt = null;
      coin.classList.remove("is-drag");
      coin.style.transform = "";
      window.setTimeout(function () { if (!dragging) coin.style.animation = ""; }, 260);
      if (!cta.disabled) cta.scrollIntoView({ block: "nearest", behavior: mqReduce.matches ? "auto" : "smooth" });
    };
    on(coin, "pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      e.preventDefault();
      coin.style.animation = "none";
      coin.style.transform = "none";
      var r = coin.getBoundingClientRect();
      rest = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      dragging = true; lastPt = null;
      coin.classList.add("is-drag");
      try { coin.setPointerCapture(e.pointerId); } catch (x) { /* ignoreras */ }
      ticket.classList.remove("is-shine");
      moveCoin(e);
    });
    on(coin, "pointermove", moveCoin);
    on(coin, "pointerup", endDrag);
    on(coin, "pointercancel", endDrag);
    on(coin, "lostpointercapture", endDrag);

    /* ---------- Skrapa åt mig ---------- */
    on(autoBtn, "click", function () {
      if (autoRunning) return;
      autoRunning = true;
      ticket.classList.remove("is-shine");
      var order = grid.concat(bonus).filter(function (c) { return !c.classList.contains("is-open"); });
      order.forEach(function (c, i) {
        timers.push(window.setTimeout(function () {
          var r = c.getBoundingClientRect();
          burst(r.left + r.width / 2, r.top + r.height / 2, 14);
          openCell(c);
          if (i === order.length - 1) autoRunning = false;
        }, i * 260));
      });
      if (!order.length) autoRunning = false;
    });

    /* ---------- Lyckohjulet ---------- */
    // Hjulet stannar alltid på slutrabatten (fält 0 eller 4), med en liten slumpad förskjutning inom fältet.
    var wheel = $("[data-lp-wheel]", root);
    var disc = $("[data-lp-disc]", root);
    var spinBtn = $("[data-lp-spin]", root);
    var spun = false;
    if (wheel) {
      disc.innerHTML = wheelSvg(wheelValues(parseFloat(wheel.dataset.prize) || 50, wheel.dataset.others));
    }
    var won = function () {
      spun = true;
      wheel.classList.remove("is-spinning");
      wheel.classList.add("is-won");
      result.textContent = result.dataset.tWon || "";
      spinBtn.hidden = true;
      cta.hidden = false;
      var r = wheel.getBoundingClientRect();
      for (var k = 0; k < 6; k++) burst(r.left + r.width / 2 + (Math.random() - 0.5) * r.width * 0.6, r.top + r.height * 0.25, 12, ["#1a1917", "#8e1d27", "#484f30", "#17396c", "#e9e5df"]);
      window.setTimeout(function () { cta.focus({ preventScroll: true }); cta.scrollIntoView({ block: "nearest", behavior: mqReduce.matches ? "auto" : "smooth" }); }, 200);
    };
    on(spinBtn, "click", function () {
      if (spun || wheel.classList.contains("is-spinning")) return;
      var seg = 360 / WHEEL_FIELDS;
      var field = Math.random() < 0.5 ? 0 : 4;                    // ett av vinstfälten
      var jitter = (Math.random() - 0.5) * seg * 0.6;             // inte exakt mitt i fältet
      var target = 360 * 6 - (field * seg + seg / 2) - jitter;    // sex varv, sedan fältets mitt under pekaren
      spinBtn.disabled = true;
      if (mqReduce.matches) { disc.style.transform = "rotate(" + target + "deg)"; won(); return; }
      wheel.classList.add("is-spinning");
      disc.style.transform = "rotate(" + target + "deg)";
      var done = false;
      var finish = function () { if (!done) { done = true; won(); } };
      on(disc, "transitionend", finish, { once: true });
      timers.push(window.setTimeout(finish, 6500)); // om transitionend uteblir
    });

    /* ---------- Steg ---------- */
    var go = function (n, noFocus) {
      step = n;
      $$("[data-lp-step]", root).forEach(function (s) { s.hidden = +s.dataset.lpStep !== n; });
      var cur = $('[data-lp-step="' + n + '"]', root);
      var h = $(".lp-h", cur);
      if (h) dialog.setAttribute("aria-labelledby", h.id);
      scroller.scrollTop = 0;
      if (n === 1) window.requestAnimationFrame(function () { paintCells(false); });
      window.requestAnimationFrame(sizeFlakes);
      if (h && !noFocus) h.focus({ preventScroll: true });
    };
    on(cta, "click", function () { if (!cta.disabled) go(2); });

    $$("[data-lp-answer]", root).forEach(function (b) {
      on(b, "click", function () {
        $$("[data-lp-answer]", root).forEach(function (o) { o.setAttribute("aria-pressed", String(o === b)); });
        var base = tags.dataset.base || "";
        var tag = (tags.dataset.prefix || "") + b.dataset.lpAnswer;
        tags.value = base ? base + ", " + tag : tag;
        go(3);
      });
    });

    var validEmail = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); };
    var showError = function (show) {
      email.setAttribute("aria-invalid", String(show));
      err.textContent = show ? err.dataset.msg : "";
    };
    on(email, "input", function () { if (email.getAttribute("aria-invalid") === "true" && validEmail(email.value.trim())) showError(false); });

    var redirect = function () { window.location.assign(cfg.redirect); };

    // Skickar formuläret med fetch (sidan laddas inte om) och går sedan vidare till Kaffeboxen,
    // oavsett vad Shopify svarar.
    var sent = false;
    var send = function () {
      if (sent) return;
      sent = true;
      var data = new FormData(form);
      var done = false;
      var finish = function () { if (done) return; done = true; redirect(); };
      window.setTimeout(finish, 4000);
      window.fetch(form.action, { method: "POST", body: data, credentials: "same-origin", headers: { Accept: "text/html" } })
        .then(finish, finish);
    };
    // Shopifys skydd mot botar (osynlig hCaptcha) kopplas på formuläret först när kunden börjar fylla i det.
    // Det fångar submit, hämtar en token och anropar sedan formulärets ursprungliga submit(). Genom att
    // byta ut submit() innan skyddet kopplas på slutar dess flöde i send() ovan, med token.
    try { form.submit = send; } catch (x) { /* ignoreras */ }

    on(form, "submit", function (e) {
      e.preventDefault();
      var v = email.value.trim();
      if (!validEmail(v)) { e.stopImmediatePropagation(); showError(true); email.focus(); return; }
      showError(false);
      email.value = v;
      if (isDesign()) { e.stopImmediatePropagation(); go(4); return; } // i redigeraren skickas inget
      writeUntil(365);
      session(TAB_KEY, null);
      go(4);
      if (form.hasAttribute("data-hcaptcha-bound")) {
        // Skyddet tar över efter den här lyssnaren. Om det inte blir klart skickas formuläret ändå.
        timers.push(window.setTimeout(send, 25000));
      } else {
        e.stopImmediatePropagation();
        send();
      }
    });

    /* ---------- Öppna, stänga, flik ---------- */
    var showTab = function (show) { if (tabWrap) tabWrap.hidden = !show; };

    var open = function () {
      if (isOpen) return;
      timers.forEach(window.clearTimeout); timers = [];
      isOpen = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      showTab(false);
      document.documentElement.classList.add("lux-pop-open");
      if (!isDesign()) { writeUntil(cfg.days); session(TAB_KEY, "1"); }
      go(step, true);
      window.requestAnimationFrame(function () {
        sizeFlakes();
        paintCells(false);
        dialog.focus({ preventScroll: true });
      });
    };

    var close = function () {
      if (!isOpen) return;
      isOpen = false;
      endDrag();
      root.hidden = true;
      document.documentElement.classList.remove("lux-pop-open");
      if (step < 4) showTab(true);
      var back = lastFocus && lastFocus !== document.body && document.contains(lastFocus) ? lastFocus : (step < 4 ? tabBtn : null);
      if (back && back.focus) back.focus({ preventScroll: true });
    };

    $$("[data-lp-close]", root).forEach(function (b) { on(b, "click", close); });
    if (tabBtn) on(tabBtn, "click", open);
    var tabX = $("[data-lp-tabclose]", wrap);
    if (tabX) on(tabX, "click", function () { showTab(false); session(TAB_KEY, null); });

    var focusables = function () {
      return $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', dialog).filter(function (el) {
        return !el.disabled && !el.closest("[hidden]") && el.getClientRects().length > 0 && el.type !== "hidden";
      });
    };
    on(document, "keydown", function (e) {
      if (!isOpen) return;
      if (e.key === "Escape") { e.preventDefault(); close(); return; }
      if (e.key !== "Tab") return;
      var list = focusables();
      if (!list.length) { e.preventDefault(); return; }
      var first = list[0], last = list[list.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || a === dialog || !dialog.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !dialog.contains(a))) { e.preventDefault(); first.focus(); }
    });
    on(document, "focusin", function (e) {
      // Iframes (t.ex. en hCaptcha-kontroll ovanpå popupen) får behålla fokus.
      if (isOpen && !dialog.contains(e.target) && e.target.tagName !== "IFRAME") dialog.focus({ preventScroll: true });
    });

    var resizeT = null;
    on(window, "resize", function () {
      if (!isOpen) return;
      window.clearTimeout(resizeT);
      resizeT = window.setTimeout(function () { sizeFlakes(); if (step === 1) paintCells(false); }, 150);
    });

    /* ---------- När lotten visas ---------- */
    // Vänta medan mobilmenyn, kundvagnen eller Shopifys cookie-ruta är öppen.
    var busy = function () {
      var pc = document.getElementById("shopify-pc__banner");
      if (pc && pc.getClientRects().length && window.getComputedStyle(pc).visibility !== "hidden") return true;
      return document.body.classList.contains("lux-drawer-open") || !!$("cart-drawer.active, details[open] > .search-modal");
    };
    var tryOpen = function () {
      if (isOpen) return;
      if (busy()) { timers.push(window.setTimeout(tryOpen, 3000)); return; }
      open();
    };

    if (ticket) newTicket();

    // Reserv till Liquid-kontrollen: aldrig på Kaffeboxens egen sida (även /collections/.../products/kaffeboxen).
    var kbPath = (root.dataset.kbPath || "").replace(/\/$/, "");
    var here = window.location.pathname.replace(/\/$/, "");
    var onKb = kbPath && kbPath.indexOf("/products/") === 0
      ? here.slice(-kbPath.length) === kbPath
      : here === kbPath;

    if (isDesign() && cfg.editorAlways) {
      open();
    } else if (onKb) {
      // ingen lott här
    } else if (readUntil() > Date.now()) {
      if (session(TAB_KEY) === "1") showTab(true);
    } else {
      if (cfg.delay > 0) timers.push(window.setTimeout(tryOpen, cfg.delay * 1000));
      if (cfg.scroll > 0) {
        var onScroll = function () {
          if (isOpen) return;
          var max = document.documentElement.scrollHeight - window.innerHeight;
          if (max > 0 && window.scrollY / max * 100 >= cfg.scroll) { window.removeEventListener("scroll", onScroll); tryOpen(); }
        };
        on(window, "scroll", onScroll, { passive: true });
      }
    }

    var inst = {
      root: root,
      open: open,
      go: go,
      destroy: function () {
        timers.forEach(window.clearTimeout);
        if (ac) ac.abort();
        document.documentElement.classList.remove("lux-pop-open");
      }
    };
    instances.push(inst);
    return inst;
  };

  var initAll = function (scope) { $$("[data-lux-pop]", scope).forEach(init); };
  var find = function (target) {
    for (var i = 0; i < instances.length; i++) if (target && target.contains(instances[i].root)) return instances[i];
    return null;
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(); });
  else initAll();

  // Temaredigeraren: koppla om när sektionen laddas om, öppna när den väljs, visa frågan när ett svar väljs.
  document.addEventListener("shopify:section:unload", function (e) {
    var inst = find(e.target);
    if (inst) { inst.destroy(); instances.splice(instances.indexOf(inst), 1); }
  });
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:section:select", function (e) { var inst = find(e.target); if (inst) inst.open(); });
  document.addEventListener("shopify:block:select", function (e) {
    var inst = find(e.target.closest(".shopify-section") || e.target);
    if (!inst) return;
    var stepEl = e.target.closest("[data-lp-step]");
    inst.open();
    inst.go(stepEl ? +stepEl.dataset.lpStep : 1, true);
  });
})();
